var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 19.25H14.6666",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.5833V19.25",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 3.66667H15.5834",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5834 3.66667V11C15.5834 12.2156 15.1005 13.3814 14.241 14.2409C13.3814 15.1005 12.2157 15.5833 11.0001 15.5833C9.78451 15.5833 8.61872 15.1005 7.75918 14.2409C6.89963 13.3814 6.41675 12.2156 6.41675 11V3.66667",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 10.0833C5.59586 10.0833 6.41667 9.26253 6.41667 8.25001C6.41667 7.23748 5.59586 6.41667 4.58333 6.41667C3.57081 6.41667 2.75 7.23748 2.75 8.25001C2.75 9.26253 3.57081 10.0833 4.58333 10.0833Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 10.0833C18.4291 10.0833 19.2499 9.26253 19.2499 8.25001C19.2499 7.23748 18.4291 6.41667 17.4166 6.41667C16.4041 6.41667 15.5833 7.23748 15.5833 8.25001C15.5833 9.26253 16.4041 10.0833 17.4166 10.0833Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.e78068ec4ed8f57698aa2437f0c4f493.svg";
export { ForwardRef as ReactComponent };